import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

import TableRow from '@mui/material/TableRow';
import { copyToClipboard } from '../../../helpers/utilityFunctions/utilityFunctions';
import { CompliancePeriod } from '../../../model/compliance/CompliancePeriod';
import { CurrentCompliancePeriod } from '../../../model/compliance/CurrentCompliancePeriod';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 'bold',
    //backgroundColor: theme.palette.common.black,
    //color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

function descendingComparator<Key extends keyof any>(
  a: {
    [key in Key]:
      | number
      | string
      | boolean
      | CurrentCompliancePeriod
      | CompliancePeriod
      | null;
  },
  b: {
    [key in Key]:
      | number
      | string
      | boolean
      | CurrentCompliancePeriod
      | CompliancePeriod
      | null;
  },
  orderBy: Key
) {
  const aValue = a[orderBy];
  const bValue = b[orderBy];

  // Special handling for objects like CurrentCompliancePeriod
  if (typeof aValue === 'object' && aValue !== null && typeof bValue === 'object' && bValue !== null) {
    // Assuming you want to compare based on daysOfUse
    return (bValue as CurrentCompliancePeriod).daysOfUse <
      (aValue as CurrentCompliancePeriod).daysOfUse
      ? -1
      : 1;
  }

  // Normal comparison for non-empty values (descending)
  if ((bValue ?? '') < (aValue ?? '')) {
    return -1;
  }
  if ((bValue ?? '') > (aValue ?? '')) {
    return 1;
  }
  return 0;
}

export type Order = 'asc' | 'desc';

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: {
    [key in Key]:
      | number
      | string
      | boolean
      | CurrentCompliancePeriod
      | CompliancePeriod
      | null;
  },
  b: {
    [key in Key]:
      | number
      | string
      | boolean
      | CurrentCompliancePeriod
      | CompliancePeriod
      | null;
  }
) => number {
  return (a, b) => {
    const aValue = a[orderBy];
    const bValue = b[orderBy];

    // Handle null, undefined, or empty string values
    const aIsEmpty = aValue === null || aValue === undefined || aValue === '';
    const bIsEmpty = bValue === null || bValue === undefined || bValue === '';

    // If both are empty, maintain their relative order
    if (aIsEmpty && bIsEmpty) {
      return 0;
    }

    // Empty values should always go to the bottom regardless of sort order
    if (aIsEmpty) {
      return 1; // a goes after b (bottom)
    }
    if (bIsEmpty) {
      return -1; // b goes after a (bottom)
    }

    // For non-empty values, use the appropriate comparator
    return order === 'desc'
      ? descendingComparator(a, b, orderBy)
      : -descendingComparator(a, b, orderBy);
  };
}

export const copyIdToClipboard = async (patientId: string) => {
  await copyToClipboard(patientId);
};
